var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class GraphClient {
    constructor(httpClient) {
        this.graphBaseUrl = 'https://graph.microsoft.com/v1.0';
        this.graphResourceUri = 'https://graph.microsoft.com';
        this.httpClient = httpClient;
    }
    getPhoto(upn, size = undefined) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    let url = `${this.graphBaseUrl}/users/${upn}`;
                    url = `${url}/${size ? `photos/${size}x${size}/$value` : 'photo/$value'}`;
                    const { data } = yield this.httpClient.request({
                        url,
                        resource: this.graphResourceUri,
                        responseType: 'blob',
                    }, { silentError: true });
                    const reader = new FileReader();
                    reader.onload = () => {
                        if (reader.result) {
                            resolve(reader.result.toString());
                        }
                        else {
                            reject();
                        }
                    };
                    reader.readAsDataURL(data);
                }
                catch (_a) {
                    resolve(null);
                }
            }));
        });
    }
}
//# sourceMappingURL=GraphClient.js.map